import { Button } from "@/components/ui/button";
import moment from "moment";

export function PartNonRepairableSummaryHandler({
  currentExport,
  dataSave,
  exportToExcel,
}) {
  if (currentExport == "part non repairable") {
    const exportData = dataSave.part_details
      .map((obj) => {
        if (obj.part_type == "non_repairable") {
          let goodCondition = 0;
          let badCondition = 0;
          let inTransitQuantity = 0;
          let onTicketQuantity = 0;
          let totalQuantity = 0;
          dataSave.part_non_repairables.map((part_non_repairable) => {
            if (part_non_repairable.part_detail_id == obj.id) {
              if (part_non_repairable.status == "good") {
                goodCondition =
                  goodCondition + part_non_repairable.part_quantity;
              }
              if (part_non_repairable.status == "bad") {
                badCondition = badCondition + part_non_repairable.part_quantity;
              }
              if (part_non_repairable.status != "good in use") {
                totalQuantity =
                  totalQuantity + part_non_repairable.part_quantity;
              }
              if (part_non_repairable.status == "good on ticket") {
                onTicketQuantity =
                  onTicketQuantity + part_non_repairable.part_quantity;
              }
              if (
                part_non_repairable.status == "good in transit" ||
                part_non_repairable.status == "bad in transit"
              ) {
                inTransitQuantity =
                  inTransitQuantity + part_non_repairable.part_quantity;
              }
            }
          });
          return {
            "Part Name": obj.name,
            "Part Number": obj.part_number,
            "Safety Stock": obj.safety_stock,
            "Good Quantity": goodCondition,
            "Bad Quantity": badCondition,
            "In Transit Quantity": inTransitQuantity,
            "On Ticket Quantity": onTicketQuantity,
            "Total Quantity": totalQuantity,
          };
        }
      })
      .filter((obj) => obj != undefined);

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `part_non_repairable_summary_${moment().format(
              "hhmm_DDMMYYYY",
            )}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
